import { problemText, type ApiError } from '@/shared/api';

/** Eigener Satz je Grenze des Exports (50 000 Zeilen, 120 Sekunden). */
const EXPORT_PROBLEMS: Record<string, string> = {
  dynamic_pricing_history_export_limit_exceeded:
    'Der Export hätte mehr als 50 000 Zeilen – grenze Zeitraum oder Apartments ein.',
  dynamic_pricing_history_export_cancelled:
    'Der Export hat länger als 120 Sekunden gedauert und wurde abgebrochen – grenze den Zeitraum ein.',
};

export const exportProblemText = (problem: ApiError | null) =>
  problem && problemText(problem, 'Der Export wurde nicht erstellt.', { known: EXPORT_PROBLEMS });
